import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const PaddedContent = styled.div`
  padding: 12px 16px;
  margin: 0 auto;
  max-width: ${theme.maxWidth};

  ${theme.largerThan.md} {
    padding: 24px 4%;
  }
`;

export const Categories = styled.div`
  margin-top: 32px;

  ${theme.largerThan.sm} {
    margin-top: 60px;
  }
`;
